import { Controller } from "@hotwired/stimulus"
import { patch, get, post } from '@rails/request.js'
import { 
  active_tags_emails_path,
  massupdate_emails_path
} from "../routes"

export default class extends Controller {
  static values = {
    ids: Array
  }
  static targets = ["original", "multiple", "tagItems"]
  static outlets = ["email"]

  connect() {
  }

  async seens(event) {
    const response = await patch(massupdate_emails_path(), {
      body: {ids: this.idsValue, email: { seen: true }},
      responseKind: "turbo-stream"
    })
    if (response.ok) {
      const data = await response.text
      Turbo.renderStreamMessage(data)
    }
  }

  async unseens(event) {
    const response = await patch(massupdate_emails_path(), {
      body: {ids: this.idsValue, email: { seen: false }},
      responseKind: "turbo-stream"
    })
    if (response.ok) {
      const data = await response.text
      Turbo.renderStreamMessage(data)
    }
  }

  async archives(event) {
    const response = await patch(massupdate_emails_path(), {
      body: {ids: this.idsValue, email: { tags_attributes: [ { tag: "archive" } ] }},
      responseKind: "turbo-stream"
    })
    if (response.ok) {
      const data = await response.text
      Turbo.renderStreamMessage(data)
    }
  }

  async unarchives(event) {
    const response = await patch(massupdate_emails_path(), {
      body: {ids: this.idsValue, email: { email_tag_connections_attributes: [ { id: event.params.tagId, _destroy: true } ] } },
      responseKind: "turbo-stream"
    })
    if (response.ok) {
      const data = await response.text
      Turbo.renderStreamMessage(data)
    }
  }

  async deletes(event) {
    const response = await patch(massupdate_emails_path(), {
      body: {ids: this.idsValue, email: { tags_attributes: [ { tag: "trash" } ] }},
      responseKind: "turbo-stream"
    })
    if (response.ok) {
      const data = await response.text
      Turbo.renderStreamMessage(data)
    }
  }

  async undeletes(event) {
    const response = await patch(massupdate_emails_path(), {
      body: {ids: this.idsValue, email: { email_tag_connections_attributes: [ { id: event.params.tagId, _destroy: true } ] } },
      responseKind: "turbo-stream"
    })
    if (response.ok) {
      const data = await response.text
      Turbo.renderStreamMessage(data)
    }
  }

  async changeResponsibles(event) {
    const response = await patch(massupdate_emails_path(), {
      body: {ids: this.idsValue, email: { responsible_id: event.params.responsibleId }},
      responseKind: "turbo-stream"
    })
    if (response.ok) {
      const data = await response.text
      Turbo.renderStreamMessage(data)
    }
  }

  async changeTags(event) {
    let attr = {}

    let item = event.target.querySelector("input[type='checkbox']")
    if (item && item.checked) {
      attr = { email_tag_id: item.value, _destroy: true }
    } else {
      attr = { email_tag_id: item.value }
    }

    const response = await patch(massupdate_emails_path(), {
      body: {ids: this.idsValue, email: { email_tag_connections_attributes: [attr] }},
      responseKind: "turbo-stream"
    })
    if (response.ok) {
      const data = await response.text
      Turbo.renderStreamMessage(data)
    }
  }

  async newtag(event) {
    const response = await patch(massupdate_emails_path(), {
      body: {ids: this.idsValue, email: { email_tag_connections_attributes: { email_tag_attributes: { tag: event.target.value } } } },
      responseKind: "turbo-stream"
    })
    if (response.ok) {
      const data = await response.text
      Turbo.renderStreamMessage(data)
    }
  }

  async refreshTags(event) {
    const response = await get(active_tags_emails_path({ids: this.idsValue}), {
      responseKind: "json"
    })
    if (response.ok) {
      const data = await response.json
      const checkboxes = this.tagItemsTarget.querySelectorAll("input[type='checkbox']");
      checkboxes.forEach(checkbox => {
        checkbox.checked = false
        for (let tagid of data) {
          if (tagid == checkbox.value) {
            checkbox.checked = true;
            break;
          }
        }
      });
    }
  }

  async changeStatuses(event) {
    const response = await patch(massupdate_emails_path(), {
      body: {ids: this.idsValue, email: { status: event.params.status }},
      responseKind: "turbo-stream"
    })
    if (response.ok) {
      const data = await response.text
      Turbo.renderStreamMessage(data)
    }
  }

  selectall(event) {
    this.emailOutletElements.forEach(emailitem => {
      emailitem.querySelector("input[type='checkbox']").checked = true;
    });
  }

  unselectall(event) {
    this.emailOutletElements.forEach(emailitem => {
      emailitem.querySelector("input[type='checkbox']").checked = false;
    });
    this.showOriginalActionsToolbar(event);
  }

  showMultipleActionsToolbar(event) {
    this.originalTarget.classList.toggle('d-none', true);
    this.multipleTarget.classList.toggle('d-none', false);
  }

  showOriginalActionsToolbar(event) {
    this.originalTarget.classList.toggle('d-none', false);
    this.multipleTarget.classList.toggle('d-none', true);
  }
}
